import React, { useContext, useState, useEffect } from 'react';
import _ from "lodash";
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import ProductPageNavigation from './ProductPageNavigation';
import FeatureProductImages from './FeatureProductImages';
import DottedLoader from '../../DottedLoader';
import ProductAssetViewer from './ProductAssetViewer';
import ProductTextualInfo from './ProductTextualInfo';
import { Link } from "react-router-dom";
import { Row, Col, Progress, Button } from 'antd';
import ModelReferenceInfo from './ModelReferenceInfo';
import FlagSiloModal from './FlagSiloModal';
import ShareProductModal from './ShareProductModal';
import EditProductModal from './EditProductModal';
import OpenVariationModal from './OpenVariationModal';
import ProductMP4Modal from './ProductMP4Modal';
import PaymentFailureModal from '../../PaymentFailureModal/PaymentFailureModal';
import InAppPurchaseLimitModal from '../InAppPurchaseLimitModal';
import ProductDimModal from './ProductDimModal';
import Product360Spin from './Product360Spin';
import SiloComplaints from '../SiloComplaints';
import SellProductOnStore from './SellProductOnStore';
import ProductActionBar from './ProductActionBar';
import ProductVariantsContainer from './ProductVariantsContainer';
import SameBrandOtherProducts from './SameBrandOtherProducts';
import SharingModal from '../SharingModal/SharingModal';
import EntityAccessDenied from '../EntityAccessDenied/EntityAccessDenied';
import AmazonImageSelectionModal from './AmazonImageSelectionModal';
import AmazonRejectionFeedbackModal from './AmazonRejectionFeedbackModal';
import { HistoryOutlined, RedoOutlined, DeleteOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';

const conicColors = {
    '0%': '#7883DC',
    '50%': '#276DD7',
    '100%': '#91D5FF',
};
const CUSTOMER_USERNAME = localStorage.getItem('username');

const ProductPage = (props) => {
    const { product_id, cognito_username, companyId, complaints,
        productDataLoader, inAppLimitExceededModal, setInAppLimitExceededModal,
        paymentFailureModal, productAssetData,
        updatePaymentDetailsOnFailure, paymentFailureMessage, setPaymentFailureModal,
        complaintsView, setComplaintsView, viewComplaintsListener, isStorePage, setSharingModal, 
        sharingModal, publicLinks, userAccessLevel,  modelStatus, aiModelProgressMessage, 
        aiModelProgressPercentage, aiRequestSubmittedOn, isAiModel, aiRequestId, setModelStatus, 
        setAiRequestSubmittedOn, aiModelJobStatus, aiInputImage, aiPromptText, aiInspirationImage } = useContext(CustomerProductContext);

    const [buttonLoader, setButtonLoader] = useState(null);

    const regenerateRequest = () => {
        setButtonLoader('regenerate');
        if(aiRequestId){
            if(isAiModel && (modelStatus == 13 || modelStatus == 15)){
                // regenerate AI model as well, since it wasn't generated
                let regenModelPayload = {
                    action: 'regenerate_model_generation_job',
                    product_id: product_id
                }
                axios.post(ENVIRONMENT.AI_MODEL_HELPER, regenModelPayload)
            }

            if(modelStatus == 13 || modelStatus == 14){
                // regenerate lifestyle job
                let payload = {
                    action: "regenerate_job",
                    request_id: aiRequestId,
                }
                axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload)
            }
            setTimeout(() => window.location.reload(), 1000)
        }
        else{
            console.log("No aiRequestId");
        }
    }

    const hideProduct = () => {
        let payload = {
            is_hidden: true,
            product_id: product_id, 
            username: CUSTOMER_USERNAME
        }
        axios.post(ENVIRONMENT.UPDATE_PRODUCT, payload).then((res) => {
            window.location.href = '/ai-asset-creator'
        })
    }

    const goToLibrary = () => {
        window.location.href = '/list-products?entity_id=' + product_id;
    }
    let complaints_bread_crumbs = !productDataLoader && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h2 className="manrope f-14 w-600" style={{ marginBottom: 10, display: 'flex', cursor: 'pointer' }}>
            <span onMouseDown={goToLibrary} className="store-bd">{"Product Library"}</span>
            {complaintsView ?
                <span style={{ color: "#9A9A9A", display: 'flex' }}>
                    <Link className='manrope clamp-text w-60 active-route-link-color' to={`/products/${product_id}`} onClick={() => setComplaintsView(false)}>
                        {' / ' + productAssetData.product_name}</Link>{' / Complaints'}
                </span> :
                <span className="active-route-link-color">{' / ' + productAssetData.product_name}</span>
            }
        </h2>
    </div>



    return (<>{
        productDataLoader ? <DottedLoader /> :
        userAccessLevel == 'restricted' ? 
            <EntityAccessDenied entityType='product' />
        :
            !complaintsView ? <>
                <ProductPageNavigation />
                {/* AI Model progress loader */}
                <Row style={{padding: '20px'}}>
                    {[13,14,15].includes(modelStatus) && aiModelJobStatus !== 'failed' && 
                        <Col span={24} style={{padding: 20, backgroundColor: '#FAFAFA'}}>
                            
                            <div style={{display: 'flex'}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
                                    <path d="M13.6621 24.5751C14.0526 24.8536 14.5204 25.0032 15 25.0027C15.4797 25.0023 15.9472 24.8519 16.3371 24.5726C16.7269 24.2812 17.0232 23.8824 17.1896 23.4251L18.0571 20.7576C18.2652 20.1291 18.6172 19.558 19.0851 19.0896C19.553 18.6213 20.1239 18.2688 20.7521 18.0601L23.4671 17.1776C23.9224 17.0143 24.3149 16.712 24.5891 16.3135C24.8633 15.915 25.0053 15.4404 24.995 14.9568C24.9848 14.4732 24.8229 14.005 24.5321 13.6185C24.2413 13.2319 23.8364 12.9465 23.3746 12.8026L20.7021 11.9376C20.0732 11.7298 19.5015 11.378 19.0328 10.91C18.564 10.4421 18.211 9.87113 18.0021 9.24259L17.1196 6.53259C16.9595 6.08507 16.6646 5.69816 16.2756 5.42508C15.8865 5.15199 15.4224 5.00614 14.9471 5.00759C14.465 5.00554 13.9944 5.15504 13.6019 5.43497C13.2094 5.7149 12.9147 6.1111 12.7596 6.56759L11.8696 9.29259C11.6606 9.90249 11.3164 10.4572 10.8627 10.9153C10.409 11.3733 9.85752 11.7228 9.24962 11.9376L6.53962 12.8151C6.08689 12.9751 5.69535 13.2723 5.41956 13.6654C5.14377 14.0585 4.99746 14.5278 5.00104 15.0079C5.00462 15.4881 5.1579 15.9552 5.43951 16.3441C5.72113 16.733 6.11706 17.0244 6.57212 17.1776L9.23962 18.0451C9.86941 18.2555 10.4415 18.6097 10.9106 19.0797C11.3797 19.5496 11.7329 20.1224 11.9421 20.7526L12.8221 23.4526C12.9796 23.9026 13.2746 24.2951 13.6646 24.5726M10.0171 15.6576L7.87962 14.9951L10.0396 14.2926C11.0261 13.9527 11.9203 13.3888 12.6521 12.6451C13.3821 11.8951 13.9321 10.9951 14.2621 10.0051L14.9246 7.85759L15.6246 10.0126C15.9561 11.0129 16.5173 11.9217 17.2631 12.6662C18.0089 13.4108 18.9187 13.9703 19.9196 14.3001L22.1196 14.9726L19.9696 15.6726C18.9679 16.0031 18.0576 16.5638 17.3117 17.3097C16.5658 18.0556 16.0051 18.9659 15.6746 19.9676L15.0121 22.1101L14.3146 19.9626C13.9848 18.9592 13.4242 18.0472 12.6778 17.3C11.9314 16.5527 11.0201 15.9885 10.0171 15.6576ZM26.3346 34.6276C26.6741 34.869 27.0805 34.9983 27.4971 34.9976C27.9169 34.9934 28.325 34.8588 28.665 34.6124C29.0049 34.3661 29.2599 34.0202 29.3946 33.6226L30.0146 31.7176C30.1471 31.3226 30.3721 30.9601 30.6646 30.6651C30.9571 30.3701 31.3196 30.1476 31.7146 30.0176L33.6446 29.3876C34.0438 29.2507 34.3895 28.9911 34.6322 28.6458C34.8748 28.3006 35.0021 27.8874 34.9957 27.4655C34.9893 27.0435 34.8496 26.6344 34.5966 26.2966C34.3436 25.9589 33.9903 25.7098 33.5871 25.5851L31.6771 24.9626C31.2822 24.8303 30.9233 24.6085 30.6284 24.3144C30.3335 24.0204 30.1106 23.6621 29.9771 23.2676L29.3471 21.3326C29.2116 20.9352 28.9544 20.5906 28.6121 20.3475C28.2697 20.1044 27.8596 19.9752 27.4397 19.9783C27.0199 19.9813 26.6116 20.1164 26.2728 20.3644C25.934 20.6124 25.6819 20.9608 25.5521 21.3601L24.9346 23.2651C24.8073 23.6567 24.5912 24.0137 24.3033 24.3081C24.0153 24.6025 23.6633 24.8265 23.2746 24.9626L21.3346 25.5951C21.041 25.6972 20.7752 25.8663 20.5583 26.0891C20.3414 26.3119 20.1795 26.5822 20.0853 26.8785C19.9912 27.1748 19.9674 27.4889 20.0159 27.796C20.0644 28.1031 20.1838 28.3947 20.3646 28.6476C20.6121 28.9976 20.9621 29.2601 21.3646 29.3976L23.2721 30.0151C23.6684 30.1486 24.0281 30.3724 24.3232 30.6687C24.6182 30.965 24.8403 31.3258 24.9721 31.7226L25.6046 33.6576C25.7416 34.0487 25.9967 34.3877 26.3346 34.6276ZM24.0496 27.6451L23.6046 27.4976L24.0646 27.3376C24.8228 27.0751 25.5103 26.6416 26.0739 26.0706C26.6375 25.4997 27.062 24.8066 27.3146 24.0451L27.4596 23.6001L27.6096 24.0526C27.8649 24.8188 28.2951 25.515 28.8661 26.0861C29.4372 26.6571 30.1334 27.0873 30.8996 27.3426L31.3871 27.5001L30.9371 27.6476C30.1691 27.9038 29.4715 28.3357 28.8999 28.9091C28.3283 29.4824 27.8985 30.1813 27.6446 30.9501L27.4971 31.4026L27.3521 30.9501C27.0996 30.1791 26.6694 29.4782 26.0962 28.9041C25.5229 28.33 24.8227 27.8987 24.0521 27.6451" fill="url(#paint0_linear_1_35655)"/>
                                    <defs>
                                        <linearGradient id="paint0_linear_1_35655" x1="12.4689" y1="-27.3816" x2="50.1956" y2="-15.2913" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#7883DC"/>
                                        <stop offset="0.5" stop-color="#276DD7"/>
                                        <stop offset="1" stop-color="#91D5FF"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <div className='manrope f-16' style={{paddingLeft: 10}} >{aiModelProgressMessage}...</div>
                                <div className='manrope f-12' style={{marginLeft: 'auto', alignContent: 'center'}}>You can <a href='/list-products'>browse your product library</a> while you wait.</div>
                            </div>
                            <div style={{display: 'flex', width: '100%'}}>
                                <div style={{ whiteSpace: 'nowrap', marginRight: '8px' }} >{aiModelProgressPercentage}% Complete</div>
                                <Progress  percent={aiModelProgressPercentage} showInfo={false}  strokeColor={conicColors}/>
                            </div>
                        </Col>
                    }

                    {aiModelJobStatus === 'failed' && 
                        <Col span={24} style={{paddingRight: 18}} className="timed-out-ai-job-container">
                            <div className="d-flex" style={{justifyContent: 'space-between'}}>
                                <div className="timed-out-ai-job-error">
                                    <div className="manrope f-16 w-500 mb-8"><HistoryOutlined className="mr-10" style={{fontSize: 24}} />It looks like your request timed out.</div>
                                    <div className="manrope f-14 w-500">
                                        No worries—please try again, or adjust your prompt for the best results.
                                    </div>
                                </div>

                                <div className="d-flex">
                                    <Button className="modal-okay-gray ai-failed-job-button square font-14 mr-16 mt-4 mb-4" style={{color: "black" }} onClick={() => window.location.href = (`/ai-asset-creator?stage=lifestyle_generation&productId=${product_id}&aiModel=true&img=${aiInputImage}&prompt=${aiPromptText}&imgInspection=${aiInspirationImage}`)} >
                                       {buttonLoader == 'regenerate' ? <LoadingOutlined /> : <RedoOutlined />} Try again
                                    </Button>
                                    <Button className="modal-okay-gray ai-failed-job-button square font-14 mr-16 mt-4 mb-4" style={{color: "black" }} onClick={() => window.location.href = (`/ai-asset-creator?stage=lifestyle_generation&productId=${product_id}&aiModel=true&img=${aiInputImage}&prompt=${aiPromptText}&imgInspection=${aiInspirationImage}`)}>
                                        <EditOutlined /> Generate More
                                    </Button>
                                    
                                    <Button className="modal-okay-gray square font-14 ai-failed-job-button mt-4 mb-4" style={{color: "#D93025" }} onClick={() =>  hideProduct()}>
                                        <DeleteOutlined /> Remove
                                    </Button>
                                </div>
                            </div>
                        </Col>                    
                    }
                </Row>
                <Row className='display-flex j-s a-s no-wrap product-section-1'>
                    <FeatureProductImages />
                    <ProductTextualInfo />
                </Row>
                <ProductVariantsContainer />
                {isStorePage && <SameBrandOtherProducts />}
                {!isStorePage &&
                    <ModelReferenceInfo context_for={"product_page"} />}
                <ProductAssetViewer />
                {!isStorePage &&
                    <ProductActionBar />}
                <FlagSiloModal context_type={"product"}/>
                <SharingModal 
                    entityId={product_id}
                    entityType={'product'}
                    setSharingModal={setSharingModal}
                    modalVisible={sharingModal}
                    publicLinks={publicLinks}
                    loggedInUserAccess={userAccessLevel}
                />
                <EditProductModal />
                <ProductMP4Modal />
                <ProductDimModal />
                <Product360Spin />
                <SellProductOnStore />
                <AmazonImageSelectionModal />
                <AmazonRejectionFeedbackModal />

                <PaymentFailureModal
                    paymentFailureMessage={paymentFailureMessage}
                    setPaymentFailureModal={setPaymentFailureModal}
                    updatePaymentDetailsOnFailure={updatePaymentDetailsOnFailure}
                    paymentFailureModal={paymentFailureModal}
                />
                <InAppPurchaseLimitModal visible={inAppLimitExceededModal} setVisible={setInAppLimitExceededModal} />
            </> : <SiloComplaints
                productAssetData={productAssetData}
                bread_crumbs={complaints_bread_crumbs}
                companyId={companyId}
                username={cognito_username}
                product_id={product_id}
                complaints={complaints}
                viewComplaintsListener={viewComplaintsListener}
                setComplaintsView={setComplaintsView} />}
    </>)
}

export default ProductPage;